import { useNavigate } from 'react-router-dom';
import { Urls } from '@/constants/urls';
import { LockIcon } from '@/components/icons/lock-icon';

export function Header() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.location.href = Urls.homepage;
    }
  };

  return (
    <>
      {/* Mobile header: back button | centered logo | lock */}
      <header className="relative flex items-center justify-between py-3 lg:hidden">
        <button
          type="button"
          onClick={handleBack}
          className="flex items-center gap-1 text-sm text-catch-dark-blue-90"
          aria-label="Go back"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          <span>Back</span>
        </button>

        <a href={Urls.homepage} className="absolute left-1/2 -translate-x-1/2">
          <img src="/images/logo-catch-dark.svg" alt="Catch" className="h-5 w-auto" />
        </a>

        <LockIcon className="h-4 w-4 text-catch-dark-blue-90" />
      </header>

      {/* Desktop header: logo + secure checkout indicator */}
      <header className="hidden items-center justify-between py-4 lg:flex">
        <a href={Urls.homepage}>
          <img src="/images/logo-beta.svg" alt="Catch" className="h-8 w-auto" />
        </a>

        <div className="flex items-center gap-1.5 text-slate-500">
          <img
            src="/images/icons/payment-page-v2/icon-ssl-lock.svg"
            alt=""
            className="h-4 w-4 opacity-60"
          />
          <span className="text-sm">Secure checkout</span>
        </div>
      </header>
    </>
  );
}

export default Header;
